/*
 * @Author: cc
 * @Date: 2020-12-25 19:16:59
 * @LastEditTime: 2021-12-30 17:00:50
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\iWo\myManuscript\manuscriptArchives\iWoManuscriptArchives.js
 * @Description: 稿件档案模块
 */
'use strict';
angular.module('iWoManuscriptArchivesModule', []).controller('iWoManuscriptArchivesCtrl', [
    '$scope',
    '$q',
    '$window',
    '$filter',
    'trsHttpService',
    'initSingleSelecet',
    'modalDialog',
    'iWoService',
    'editcenterRightsService',
    'trsspliceString',
    'editingCenterService',
    'storageListenerService',
    'globleParamsSet',
    'trsPrintService',
    'myManuscriptService',
    function(
        $scope,
        $q,
        $window,
        $filter,
        trsHttpService,
        initSingleSelecet,
        modalDialog,
        iWoService,
        editcenterRightsService,
        trsspliceString,
        editingCenterService,
        storageListenerService,
        globleParamsSet,
        trsPrintService,
        myManuscriptService
    ) {
        initStatus();
        initData();

        /**
         * [initStatus description]初始化状态函数开始
         * @return {[type]} [description] null
         */
        function initStatus() {
            $scope.page = {
                CURRPAGE: '1',
                PAGESIZE: globleParamsSet.getPageSize(),
                ITEMCOUNT: 0,
                PAGECOUNT: 1,
            };
            $scope.status = {
                params: {
                    serviceid: 'mlf_releaseSource',
                    methodname: 'queryDocRecords',
                    CurrPage: $scope.page.CURRPAGE,
                    PageSize: $scope.page.PAGESIZE,
                },
                channelTypes: [
                    {
                        name: '我的',
                        value: '-1',
                    },
                    {
                        name: '客户端',
                        value: '1',
                    },
                    {
                        name: '网站',
                        value: '2',
                    },
                    {
                        name: '微信',
                        value: '4',
                    },
                ],
                selectedChannelType: {
                    name: '我的',
                    value: '-1',
                },
                copyCurrPage: 1,
                isHandle: false, // 是否经手稿
                isOnlyMine: false, // 是否本人创建稿
                isESSearch: false, // 是否通过ES检索列表
                btnRights: [],
                methodname: {
                    1: 'getNewsDoc',
                    2: 'getPicsDoc',
                },
                batchOperateBtn: {
                    hoverStatus: '',
                    clickStatus: '',
                },
                draftType: {
                    news: '1',
                    atlas: '2',
                    subject: '3',
                    linkDoc: '4',
                    activity: '5',
                    topic: '6',
                    video: '7',
                    live: '8',
                    manuscript: '9',
                    seriesSheet: '11',
                },
                sourceid: '',
                serviceid: {
                    '15': 'mlf_tv',
                    '16': 'mlf_broadcast',
                },
                fusionServiceid: {
                    '15': 'mlf_fusiontv',
                    '16': 'mlf_fusionbroadcast',
                },
            };
            $scope.data = {
                items: [],
                selectedArray: [],
                preview: iWoService.initPreviewPath(),
                printResult: [],
            };
        }

        /**
         * [initData description]初始化数据开始
         * @return {[type]} [description] null
         */
        function initData() {
            requestData();
            getDropDown();
            listenStorage();
            editcenterRightsService.initIwoListBtn('iwo.docrecord').then(function(rights) {
                $scope.status.btnRights = rights;
            });
        }

        /**
         * [listenStorage description]监听本地缓存
         * @return {[promise]} [description] promise
         */
        function listenStorage() {
            storageListenerService.listenIwo(function() {
                $scope.status.isESSearch = false;
                requestData();
                storageListenerService.removeListener('iwo');
            }, $scope);
        }

        $scope.queryDataByChannels = function() {
            if ($scope.status.selectedChannelType.value == '-1') {
                $scope.docTypeJsons = initSingleSelecet.iWoDocType();
            } else if ($scope.status.selectedChannelType.value == '1') {
                $scope.docTypeJsons = initSingleSelecet.appDocType();
            } else if ($scope.status.selectedChannelType.value == '2') {
                $scope.docTypeJsons = initSingleSelecet.websiteDocType();
            }
            $scope.docTypeSelected = angular.copy($scope.docTypeJsons[0]);
            return requestData();
        };

        /**
         * [queryDataByChannels description] 通过渠道检索数据
         * @param   {[type]}  ESParams  [ESParams description]
         * @return  {[type]}            [return description]
         */
        function queryDataByChannels(ESParams) {
            var params = angular.copy($scope.status.isESSearch ? ESParams : $scope.status.params);
            params.searchMediaType = $scope.status.selectedChannelType.value;
            params.methodname = $scope.status.isESSearch ? 'queryForIwoRecordDocForMedia' : 'queryDocRecordsForMediaType';
            params.docType = $scope.docTypeSelected.value;
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                var ListItems = data.DATA;
                $scope.data.items = ListItems;
                !!data.PAGER ? ($scope.page = data.PAGER) : ($scope.page.ITEMCOUNT = 0);
                $scope.data.selectedArray = [];
                requestListImg(ListItems).then(function(data) {
                    // $('[data-toggle="tooltip"]').tooltip();
                    angular.forEach(ListItems, function(value, key) {
                        value.ALLIMG = data[value.METADATAID];
                    });
                });
            });
        }

        /**
         * [requestData description]数据请求函数
         * @return {[type]}            [description]
         */
        function requestData() {
            var params = $scope.status.isESSearch ? getESSearchParams() : $scope.status.params;
            if ($scope.status.selectedChannelType.value != '-1') {
                queryDataByChannels(params);
                return;
            }
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                var ListItems = data.DATA;
                $scope.data.items = ListItems;
                !!data.PAGER ? ($scope.page = data.PAGER) : ($scope.page.ITEMCOUNT = 0);
                $scope.data.selectedArray = [];
                requestListImg(ListItems).then(function(data) {
                    // $('[data-toggle="tooltip"]').tooltip();
                    angular.forEach(ListItems, function(value, key) {
                        value.ALLIMG = data[value.METADATAID];
                    });
                });
            });
        }

        /**
         * [fusionPreview description] 融合编辑 预览
         * @param   {[type]}  item           [item description]
         * @return  {[type]}                 [return description]
         */
        $scope.fusionPreview = function(item) {
            myManuscriptService.fusionPreviewRouter(item, $scope, '', 'iwo.docrecord');
            // if ($scope.status.selectedChannelType.value != -1) {
            //     var routerParams, url;
            //     if ($scope.status.selectedChannelType.value == 1) {
            //         routerParams = {
            //             appchnldocid: item.CHNLDOCID,
            //             appdoctype: item.DOCTYPEID - 1,
            //             appmetadataid: item.METADATAID,
            //         };
            //         url = $state.href('appPreview', routerParams);
            //     } else if ($scope.status.selectedChannelType.value == 2) {
            //         routerParams = {
            //             wzchnldocid: item.CHNLDOCID,
            //             wztypeid: item.DOCTYPEID,
            //             wzmetadataid: item.METADATAID,
            //         };
            //         url = $state.href('websitePreviewAll', routerParams);
            //     } else {
            //         routerParams = {
            //             wxchnldocid: item.CHNLDOCID,
            //             // wztypeid: item.DOCTYPEID,
            //             wxmetadataid: item.METADATAID,
            //         };
            //         url = $state.href('weixinPreview', routerParams);
            //     }
            //     item.url = url;
            // } else {
            //     if (doctype == '9') {
            //         storageListenerService.previewPageTurningStorage($scope.data.items, 'METADATAID,CHNLDOCID,DOCTYPEID', 'fusionPreview'); // iwo
            //         var routerParams = {
            //             iwoplatform: 2,
            //             iwometadataid: iwometadataid,
            //             iwochnldocid: iwochnldocid,
            //             isfromplannedorder: false,
            //         };
            //         url = $state.href('iwomanuscriptpreview', routerParams);
            //         item.url = url;
            //     } else if (doctype == '11') {
            //         storageListenerService.previewPageTurningStorage($scope.data.items, 'METADATAID,CHNLDOCID,DOCTYPEID', 'fusionPreview'); // iwo
            //         var routerParams = {
            //             iwoplatform: 2,
            //             iwometadataid: iwometadataid,
            //             iwochnldocid: iwochnldocid,
            //             isfromplannedorder: false,
            //         };
            //         url = $state.href('iwoseriessheetpreview', routerParams);
            //         item.url = url;
            //     } else {
            //         storageListenerService.previewPageTurningStorage($scope.data.items, 'METADATAID,CHNLDOCID,DOCTYPEID', 'fusionPreview'); // iwoman
            //         var url,
            //             routerParams = {
            //                 iwotype: doctype,
            //                 iwomodalname: 'iwo.docrecord',
            //                 wzplatform: 0,
            //                 wztypeid: doctype,
            //                 appplatform: 0,
            //                 newspapertype: 2,
            //                 iwoplatform: 2,

            //                 iwometadataid: iwometadataid,
            //                 iwochnldocid: iwochnldocid,
            //             };
            //         routerParams.appdoctype = doctype;
            //         getBindingMediaIds(iwometadataid).then(function(bingdingData) {
            //             angular.forEach(bingdingData, function(value, key) {
            //                 if (value.MEDIATYPE == '1') {
            //                     routerParams.appsiteid = value.SITEID;
            //                     routerParams.appchannelid = value.CHANNELID;
            //                     routerParams.appchnldocid = value.CHNLDOCID;
            //                     routerParams.appmetadataid = value.VIRTUALDOCID;
            //                 } else if (value.MEDIATYPE == '2') {
            //                     routerParams.wzsiteid = value.SITEID;
            //                     routerParams.wzchannelid = value.CHANNELID;
            //                     routerParams.wzchnldocid = value.CHNLDOCID;
            //                     routerParams.wzmetadataid = value.VIRTUALDOCID;
            //                 } else if (value.MEDIATYPE == '3') {
            //                     routerParams.paperid = value.CHANNELID; // 预览页与编辑页参数不同
            //                     routerParams.bzmetadata = value.VIRTUALDOCID; // 预览页与编辑页参数不同
            //                 } else if (value.MEDIATYPE == '4') {
            //                     routerParams.wxchannelid = value.CHANNELID;
            //                     routerParams.wxchnldocid = value.CHNLDOCID;
            //                     routerParams.wxmetadataid = value.VIRTUALDOCID;
            //                 } else if (value.MEDIATYPE == '5') {
            //                     routerParams.wbmetadataid = value.VIRTUALDOCID;
            //                 }
            //             });
            //             url = $state.href('fusionpreview', routerParams);
            //             item.url = url;
            //         });
            //     }
            // }
        };

        /**
         * [getBindingMediaIds description] 获取绑定的渠道的相关id
         * @param {[type]} [iwometadataid] [description] iwo稿件id
         * @return {[type]} [description]
         */
        function getBindingMediaIds(iwometadataid) {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_fusioncreate',
                methodname: 'queryFuseMappings',
                sourceDocId: iwometadataid,
                mediaTypes: '',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                defer.resolve(data);
            });
            return defer.promise;
        }

        /**
         * [requestListImg description] 查询列表图示
         * @param   {[type]}  items  [items description]
         * @return  {[type]}         [return description]
         */
        function requestListImg(items) {
            var defer = $q.defer();
            if (!items || items.length < 1) {defer.resolve([]);} else {
                var params = {};
                if ($scope.status.selectedChannelType.value == 4) {
                    params = {
                        serviceid: 'mlf_wechatgroupsend',
                        methodname: 'queryContentPics',
                        DocIds: trsspliceString.spliceString(items, 'METADATAID', ','),
                    };
                } else {
                    params = {
                        serviceid: 'mlf_myrelease',
                        methodname: 'queryAllImgLogo',
                        metadataids: trsspliceString.spliceString(items, 'METADATAID', ','),
                    };
                }
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    defer.resolve(data);
                });
            }
            return defer.promise;
        }

        /**
         * [getESSearchParams description]设置ES检索参数
         * @return {[json]} [description] 参数对象
         */
        function getESSearchParams() {
            var esParams = {
                serviceid: 'mlf_hybasesearch',
                methodname: 'queryForIwoRecordDoc',
                searchParams: {
                    PAGESIZE: $scope.page.PAGESIZE + '',
                    PAGEINDEX: $scope.page.CURRPAGE + '',
                    searchFields: [
                        {
                            searchField: $scope.iWoEntireSelected.value,
                            keywords: $scope.keywords ? $scope.keywords : '',
                        },
                        {
                            searchField: 'docType',
                            keywords: $scope.docTypeSelected.value,
                        },
                        {
                            searchField: 'lastTimeType',
                            keywords:
                                angular.isDefined($scope.data.fromdate) && $scope.data.fromdate !== ''
                                    ? $scope.data.fromdate + ',' + $scope.data.untildate
                                    : $scope.endTimeTypeSelected.value,
                        },
                        {
                            searchField: 'isHandle',
                            keywords: $scope.status.isHandle,
                        },
                        {
                            searchField: 'isOnlyMine',
                            keywords: $scope.status.isOnlyMine,
                        },
                        {
                            searchField: '_sort',
                            keywords: $scope.sortType.value,
                        },
                    ],
                },
            };
            if ($scope.status.selectedChannelType.value != '-1') {
                esParams.searchParams.searchFields.push({
                    searchField: 'mediaType', // 稿件类型 1：app 2：网站 4微信
                    keywords: $scope.status.selectedChannelType.value,
                });
            }
            esParams.searchParams = JSON.stringify(esParams.searchParams);
            return esParams;
        }

        /**
         * [selectDoc description]单选列表
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.selectDoc = function(item) {
            if ($scope.data.selectedArray.indexOf(item) < 0) {
                $scope.data.selectedArray.push(item);
            } else {
                $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(item), 1);
            }
            cancelBatchOperate();
        };

        /**
         * [cancelBatchOperate description]取消批量操作的样式
         * @return {[type]} [description] null
         */
        function cancelBatchOperate() {
            if ($scope.data.selectedArray.length === 0) {
                $scope.status.batchOperateBtn = {
                    hoverStatus: '',
                    clickStatus: '',
                };
            }
        }

        /**
         * [copyBuildDraft description]复制建新稿
         * @param  {[object]} item [description] 页面传入对象
         * @return {[type]}      [description]
         */
        $scope.copyBuildDraft = function(item) {
            if (item.DOCTYPEID == '11') {
                modalDialog.alertType('串联单不允许复制新建稿', '', 'info', 'confirm', function() {});
                return;
            }
            $scope.status.isESSearch = false;
            iWoService.copyBuildDraft([item], 'docrecordCopyBuildDraft', function() {
                modalDialog.alertType('复制建新稿成功', '', 'success', false, function() {
                    requestData();
                });
            });
        };

        /**
         * [batchCopyBuildDraft description]批量复制建新稿
         * @return {[type]} [description]
         */
        $scope.batchCopyBuildDraft = function() {
            if (hasSeriesSheet()) {
                modalDialog.alertType('稿件中包含串联单，串联单不允许复制新建稿', '', 'info', 'confirm', function() {});
                return;
            }
            $scope.status.isESSearch = false;
            $scope.status.batchOperateBtn.clickStatus = 'batchCopyBuildDraft';
            iWoService.copyBuildDraft($scope.data.selectedArray, 'docrecordCopyBuildDraft', function() {
                modalDialog.alertType('复制建新稿成功', '', 'success', false, function() {
                    requestData();
                });
            });
        };

        /**
         * [hasSeriesSheet description]
         * @return  {[type]}  [return description]
         */
        function hasSeriesSheet() {
            return $scope.data.selectedArray.some(function(obj, index) {
                return obj.DOCTYPEID == 11;
            });
        }

        /**
         * [examDraftType description]检验稿件类型
         * @param  {[obj]} elm [description]稿件的具体信息
         * @return {[type]}     [description]
         */
        $scope.examDraftType = function(elm) {
            if (angular.isDefined(elm)) {
                return elm.DOCTYPEID != 1 && elm.DOCTYPEID != 2;
            }
        };

        $scope.exportDraft = function() {
            $scope.status.isESSearch = false;
            var temp = $filter('pick')($scope.data.selectedArray, $scope.examDraftType);
            var docIds = trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ',')
            $window.open('/wcm/app/file/download_file.jsp?docId=' + docIds);
            $scope.data.selectedArray = [];
            var params = {
                docId: docIds
            };
            trsHttpService.httpServer('/wcm/app/ct/video_info.jsp', params, 'get').then(
                function (data) {
                    if (data.length > 0) {
                        for (var i = 0; i < data.length; i++) {
                            $window.open('/transfer/aav/common/download?url=' + data[i]);
                        }
                    }
                }
            )
        };
        // $scope.exportDraft = function() {
        //     $scope.status.isESSearch = false;
        //     var temp = $filter('pick')($scope.data.selectedArray, $scope.examDraftType);
        //     if (temp.length < 1) {
        //         var params = {
        //             serviceid: 'mlf_exportword',
        //             methodname: 'exportWordFile',
        //             MetaDataIds: trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ','),
        //         };
        //         $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(
        //             function(data) {
        //                 window.open('/wcm/app/file/read_file.jsp?FileName=' + data.REPORTS[0].DETAIL);
        //                 $scope.data.selectedArray = [];
        //             },
        //             function(data) {
        //                 if (data.REPORTS[0].ISSUCCESS == 'true') {
        //                     window.open('/wcm/app/file/read_file.jsp?FileName=' + data.REPORTS[0].DETAIL);
        //                     $scope.data.selectedArray = [];
        //                 }
        //             }
        //         );
        //     } else {
        //         modalDialog.alertType('只能导出新闻稿或图集稿', '', 'error', false);
        //     }
        // };

        /**
         * [batchOutgoing description]批量外发
         * @return {[type]} [description] null
         */
        $scope.batchOutgoing = function() {
            $scope.status.isESSearch = false;
            $scope.status.batchOperateBtn.clickStatus = 'batchOutgoing';
        };

        /**
         * [selectAll description]全选列表
         * @return {[type]} [description] null
         */
        $scope.selectAll = function() {
            $scope.data.selectedArray = $scope.data.selectedArray.length == $scope.data.items.length ? [] : [].concat($scope.data.items);
            cancelBatchOperate();
        };

        /**
         * [pageChanged description]下一页
         * @return {[type]} [description] null
         */
        $scope.pageChanged = function() {
            $scope.status.params.CurrPage = $scope.page.CURRPAGE;
            $scope.status.copyCurrPage = $scope.page.CURRPAGE;
            requestData();
        };
        // 跳转到开始
        $scope.jumpToPage = function() {
            if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
                $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
            }
            $scope.status.params.CurrPage = $scope.status.copyCurrPage;
            $scope.page.CURRPAGE = $scope.status.copyCurrPage;
            requestData();
        };
        // 跳转到结束
        /**
         * [getDropDown description]
         * @return  {[type]}  [return description]
         */
        function getDropDown() {
            // 初始化类型
            $scope.docTypeJsons = initSingleSelecet.iWoDocType();
            $scope.docTypeSelected = angular.copy($scope.docTypeJsons[0]);
            // 初始化最后版本时间
            $scope.endTimeTypeJsons = initSingleSelecet.iWoOperTime();
            $scope.endTimeTypeSelected = angular.copy($scope.endTimeTypeJsons[0]);
            // 初始化全部
            $scope.iWoEntireJsons = initSingleSelecet.iWoEntire();
            $scope.iWoEntireSelected = angular.copy($scope.iWoEntireJsons[0]);
            // 排序方式
            $scope.sortTypeJsons = initSingleSelecet.sortType();
            $scope.sortType = angular.copy($scope.sortTypeJsons[1]);
        } // 爱你哦
        /**
         * [queryByDropdown description] 筛选条件触发后请求数据
         * @param  {[type]} key   [description] 请求对象参数key
         * @param  {[type]} value [description] 请求对象值
         * @return {[type]}       [description] null
         */ $scope.queryByDropdown = function(key, value) {
            $scope.status.params[key] = value;
            $scope.status.params.CurrPage = $scope.status.copyCurrPage = $scope.page.CURRPAGE = '1';
            if (key === 'OperTime') {
                $scope.status.params.OperTimeStart = $scope.data.fromdate;
                $scope.status.params.OperTimeEnd = $scope.data.untildate;
                $scope.status.params[key] = null;
            }
            requestData();
        };

        // 查询只看本人
        $scope.onlyMine = function() {
            $scope.status.isOnlyMine = !$scope.status.isOnlyMine;
            $scope.status.params.isOnlyMine = $scope.status.isOnlyMine;
            requestData();
        };
        // 查询经手稿
        $scope.handle = function() {
            $scope.status.isHandle = !$scope.status.isHandle;
            $scope.status.params.isHandle = $scope.status.isHandle;
            requestData();
        };

        /**
         * [outSending description]外发
         * @return {[type]} [description] null
         */
        $scope.outSending = function() {
            $scope.status.isESSearch = false;
            editingCenterService.outSending('', function(result) {
                outSendingDraft(result.selectItems);
            });
        };

        /**
         * [outSendingDraft description] 邮件外发
         * @param   {[type]}  items  [items description]
         * @return  {[type]}         [return description]
         */
        function outSendingDraft(items) {
            var userids = trsspliceString.spliceString(items, 'EMAIL', ',');
            var draftids = trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ',');
            var params = {
                serviceid: 'mlf_mailoutgoingOper',
                methodname: 'iRecordSendEmail',
                Emails: userids,
                MetaDataIds: draftids,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                modalDialog.alertType('邮件外发成功', '', 'success', false, function() {
                    requestData();
                });
            });
        }
        // 选择单页显示个数
        $scope.selectPageNum = function() {
            $scope.status.params.PageSize = $scope.page.PAGESIZE;
            $scope.status.params.CurrPage = $scope.page.CURRPAGE;
            $scope.status.copyCurrPage = 1;
            requestData();
        };

        /**
         * [showVersionTime description] 流程版本时间与操作日志
         * @param   {[type]}  item  [item description]
         * @return  {[type]}        [return description]
         */
        $scope.showVersionTime = function(item) {
            editingCenterService.getVersionTime(item, true);
        };

        /**
         * [fullTextSearch description] 全文检索
         * @param   {[object]}  ev  [ev description] 事件对象
         * @return  {[type]}        [return description]
         */
        $scope.fullTextSearch = function(ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                $scope.status.isESSearch = true;
                $scope.page.CURRPAGE = 1;
                requestData();
            }
        };

        /**
         * [printBtn description] 打印
         * @return  {[type]}  [return description]
         */
        $scope.printBtn = function() {
            $scope.status.isESSearch = false;
            if (!allowPrint()) {
                modalDialog.alertType('只能打印新闻、图集、串联单、广电文稿', '', 'warning', 'confirm');
                return;
            }
            if (!hasBroadcastManuscript()) {
                // 判断是否只有广电广电文稿和串联单
                if (hasNewsAndPicture()) {
                    // 是否为纯新闻和图集稿
                    angular.forEach($scope.data.selectedArray, function(value, key) {
                        requestPrintData(value);
                    });
                } else {
                    modalDialog.alertType('只能单独打印串联单和广电文稿', '', 'warning', 'confirm');
                    return;
                }
            } else {
                angular.forEach($scope.data.selectedArray, function(value, key) {
                    getBroadcastData(value, value.DOCTYPEID);
                });
            }

            /**
             * [allowPrint description] 是否允许打印
             * @return {[boolean]} [description]
             */
            function allowPrint() {
                var flag = true;
                for (var i in $scope.data.selectedArray) {
                    var item = $scope.data.selectedArray[i];
                    if (item.DOCTYPEID !== '1' && item.DOCTYPEID !== '2' && item.DOCTYPEID !== '9' && item.DOCTYPEID !== '11') {
                        flag = false;
                        break;
                    }
                }
                return flag;
            }
        };

        /**
         * [hasBroadcastManuscript 判断是否包含广电广电文稿和串联单]
         * @return {Boolean} [description]
         */
        function hasBroadcastManuscript() {
            var flag;
            flag = $scope.data.selectedArray.every(function(item, index, array) {
                return item.DOCTYPEID == '9' || item.DOCTYPEID == '11';
            });
            return flag;
        }

        /**
         * [hasBroadcastManuscript 是否包含新闻、图集]
         * @return {Boolean} [description]
         */
        function hasNewsAndPicture() {
            var flag;
            flag = $scope.data.selectedArray.every(function(item, index, array) {
                return item.DOCTYPEID == '1' || item.DOCTYPEID == '2';
            });
            return flag;
        }

        /**
         * [queryChannelForMetadataid description] 查询串联单所属渠道
         * @param   {[type]}  item  [item description]
         * @return  {[type]}        [return description]
         */
        function queryChannelForMetadataid(item) {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_fusioncreate',
                methodname: 'queryDocMediaType',
                ObjectId: item.METADATAID,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.status.sourceid = data.MSG;
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [getBroadcastData 获取稿件详情]
         * @param  {[type]} item [description]
         * @param  {[type]} type [description]
         * @return {[type]}      [description]
         */
        function getBroadcastData(item, type) {
            if (type == '9') {
                var params = {
                    serviceid: 'mlf_fusiontv',
                    methodname: 'getVirtualWenGaoDoc',
                    SourceDocId: item.METADATAID,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    var result = data;
                    data.PLATFORM = 'iwo';
                    // data.VERSION = version;
                    // data.HANGCOUNT = Math.ceil(data.DOCWORDSCOUNT / 27);
                    $scope.data.printResult.push(result);
                    if ($scope.data.printResult.length == $scope.data.selectedArray.length) {
                        trsPrintService.trsTvPrintDocument($scope.data.printResult);
                        $scope.data.printResult = [];
                    }
                });
            } else {
                queryChannelForMetadataid(item).then(function() {
                    var params = {
                        serviceid: $scope.status.fusionServiceid[$scope.status.sourceid],
                        methodname: 'getVirtualChuanLianDoc',
                        SourceDocId: item.METADATAID,
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                        getSeriessheetList(data);
                    });
                });
            }
        }

        /**
         * [getSeriessheetList description] 获取串联单关联稿件
         * @param   {[type]}  result  [result description]
         * @return  {[type]}          [return description]
         */
        function getSeriessheetList(result) {
            var params = {
                serviceid: 'mlf_tv',
                methodname: 'queryQuoteDocListsToJSON',
                SeriesDocId: result.METADATAID,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                result.ITEMS = data;
                $scope.data.printResult.push(result);
                if ($scope.data.printResult.length === $scope.data.selectedArray.length) {
                    trsPrintService.trsTvPrintDocument($scope.data.printResult);
                    $scope.data.printResult = [];
                }
            });
        }

        /**
         * [requestPrintData description] 打印请求详情
         * @param   {[type]}  item     [item description]
         * @param   {[type]}  version  [version description]
         * @return  {[type]}           [return description]
         */
        function requestPrintData(item, version) {
            var params = {
                serviceid: 'mlf_myrelease',
                methodname: $scope.status.methodname[item.DOCTYPEID],
                MetaDataId: item.METADATAID,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                var result = data;
                data.VERSION = version;
                data.HANGCOUNT = Math.ceil(data.DOCWORDSCOUNT / 27);
                $scope.data.printResult.push(result);
                if ($scope.data.printResult.length === $scope.data.selectedArray.length) {
                    trsPrintService.trsIwoPrintDocument($scope.data.printResult);
                    $scope.data.printResult = [];
                }
            });
        }
    },
]);
